import { GET_AI_TOGGLE, GET_APPLE_LOGIN_TOGGLE, GET_SETTINGS } from "../actions/types";
const initialState = {
  goldBidMapping: {},
  appVersion: null,
  showAI: 1,
  appleLogin: 1
};

const getToggleValue = (payload, currentValue, keys) => {
  if (payload && typeof payload === "object") {
    const payloadValue = keys.find((key) => payload[key] !== undefined);
    const settingValue = keys.find((key) => payload.setting?.[key] !== undefined);
    const dataValue = keys.find((key) => payload.data?.[key] !== undefined);

    return payload[payloadValue] ?? payload.setting?.[settingValue] ?? payload.data?.[dataValue] ?? currentValue;
  }

  return payload ?? currentValue;
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SETTINGS:
      return {
        ...state,
        goldBidMapping: payload?.goldBidMapping || {},
        appVersion: payload?.appVersion || null
      };
    case GET_AI_TOGGLE:
      return {
        ...state,
        showAI: Number(getToggleValue(payload, state.showAI, ["showAI"]))
      };
    case GET_APPLE_LOGIN_TOGGLE:
      return {
        ...state,
        appleLogin: Number(getToggleValue(payload, state.appleLogin, ["appleLogin", "showAppleLogin", "appleLoginToggle"]))
      };

    default:
      return state;
  }
}
